import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { WorkingGroupComponent } from "./components/workingGroups/workingGroup.component";
import { SignalsRegistrationListComponent } from "./components/signals-registration-list/signals-registration-list.component";
import { UnitsComponent } from "./components/nomenclatures/units/units.component";
import { MaterialsComponent } from "./components/materials/materials.component";
import { EmergenciesListComponent } from "./components/emergencies-list/emergencies-list.component";
import { MechanisationComponent } from "./components/mechanisation/mechanisation.component";
import { AvariiTypeComponent } from "./components/nomenclatures/avarii-type/avarii-type.component";
import { SignalsMapListComponent } from "./components/signals-registration-list/signal-map-list/signal-map-list.component";


export const routes: Routes = [
  { path: 'workingGroups', component: WorkingGroupComponent },
  { path: 'signals', component: SignalsRegistrationListComponent},
  { path: 'emergencies', component: EmergenciesListComponent},
  { path: 'nom/units', component: UnitsComponent},
  { path: 'nom/materials', component: MaterialsComponent},
  { path: 'nom/mechanisation', component: MechanisationComponent},
  { path: 'nom/avariitype', component: AvariiTypeComponent },
  { path: 'map', component: SignalsMapListComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class VikRoutingModule { }
